import "core-js/modules/es.array.push.js";
import { ImageColour } from "@/jsUtils/imageColour.js";
import { Product_Info } from "@/globalcfg";
import beyondWarn from "@/components/tools/beyondWarn.vue";
export default {
  components: {
    beyondWarn
  },
  data() {
    return {
      dataList: [],
      imageColour: undefined,
      numfontsize: "25px"
    };
  },
  props: {
    particelImg: {
      Type: String,
      required: true
    },
    //数据列表，每一条数据必须包含iconpath字段
    particelList: {
      Type: Array,
      default: []
    }
  },
  watch: {
    particelList() {
      this.updateList();
    },
    particelImg: {
      handler: function (val, oldVal) {
        if (this.imageColour != undefined) {
          this.imageColour = null;
          this.imageColour = new ImageColour(val);
        }
      },
      deep: true
    }
  },
  mounted: function () {
    let particleimg = null;
    if (this.particelImg == null || this.particelImg == undefined) {
      // particleimg = Product_Info['littlebrick'].particle_img;
      particleimg = Product_Info.Origin.particle_img;
    } else {
      particleimg = this.particelImg;
    }
    this.imageColour = new ImageColour(particleimg);
    this.updateList();

    // let clientWidth = document.documentElement.clientWidth;
    // if (clientWidth > default_max_width)
    // {
    //   clientWidth = default_max_width;
    // }

    // if (this.$refs.particle_title != undefined)
    // {
    //   this.$refs.particle_title.style.fontSize = clientWidth / 20 + "px";
    // }
  },

  methods: {
    //更新颗粒列表
    updateList() {
      this.dataList = [];

      // console.log(" watch particelList length ", this.particelList.length);
      // console.dir(this.particelList);
      // console.log(" show particelImg ", this.particelImg);

      for (var i = 0; i < this.particelList.length; i++) {
        let num = this.particelList[i].number;
        let usednum = this.particelList[i].usednum;
        if (usednum == 0) {
          continue;
        }
        this.imageColour.convert(this.particelList[i].rgb, this.particelList[i].seq, this.particelList[i].fontRgb, particelImg => {
          this.dataList.push({
            particelImg: particelImg,
            num: num,
            usednum: usednum
          });
        });
      }
    }
  }
};